import { c as _c } from "react-compiler-runtime";
/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

import { is } from 'immutable';
// @ts-ignore - Remove once type definitions are available
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import { MESSAGE_ID_ATTR } from '../../../web/message-history/constants/constants';
// @ts-ignore - Remove once type definitions are available
import { getMessageId } from '../../../message-history/operators/getMessageId';
import { memo } from 'react';
import { areSenderMapsEqual } from '../../../senders/operators/areSenderMapsEqual';
import { jsx as _jsx } from "react/jsx-runtime";
const shouldRerender = (prev, next) => {
  return !Object.keys(prev).some(key => {
    if (key === 'senders') {
      return !areSenderMapsEqual(prev.senders, next.senders);
    }
    if (key === 'positionDescriptors') {
      return !is(prev[key], next[key]);
    }
    // @ts-ignore Leaving exisitng logic in place while converting to TS to prevent as many runtime changes as possible. Issue to fix: https://github.com/HubSpotEngineering/context-and-collab-projects/issues/1654
    return prev[key] !== next[key];
  });
};
const MessageHistoryItem = /*#__PURE__*/memo(t0 => {
  const $ = _c(23);
  const {
    fileAttachmentsForMessage,
    fileAttachmentsMap,
    friendlyNames,
    hiddenBy,
    historyConfig,
    message,
    positionDescriptors,
    presentSenderLocators,
    senders,
    recipientsMap,
    visitorLastReadTimestamp,
    visitorRecipients,
    threadId,
    channelName,
    slots,
    isLastMessage,
    getChirpThreadHistoryMessageById
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = getMessageId(message);
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      [MESSAGE_ID_ATTR]: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const idAttr = t2;
  const type = getType(message);
  const Component = historyConfig[type];
  let t3;
  if ($[4] !== Component || $[5] !== channelName || $[6] !== fileAttachmentsForMessage || $[7] !== fileAttachmentsMap || $[8] !== friendlyNames || $[9] !== getChirpThreadHistoryMessageById || $[10] !== hiddenBy || $[11] !== idAttr || $[12] !== isLastMessage || $[13] !== message || $[14] !== positionDescriptors || $[15] !== presentSenderLocators || $[16] !== recipientsMap || $[17] !== senders || $[18] !== slots || $[19] !== threadId || $[20] !== visitorLastReadTimestamp || $[21] !== visitorRecipients) {
    t3 = Component ? /*#__PURE__*/_jsx("div", Object.assign({}, idAttr, {
      children: /*#__PURE__*/_jsx(Component, {
        channelName: channelName,
        fileAttachmentsForMessage: fileAttachmentsForMessage,
        fileAttachmentsMap: fileAttachmentsMap,
        friendlyNames: friendlyNames,
        hiddenBy: hiddenBy,
        message: message,
        positionDescriptors: positionDescriptors,
        senders: senders,
        recipientsMap: recipientsMap,
        presentSenderLocators: presentSenderLocators,
        visitorLastReadTimestamp: visitorLastReadTimestamp,
        visitorRecipients: visitorRecipients,
        threadId: threadId,
        slots: slots,
        isLastMessage: isLastMessage,
        getChirpThreadHistoryMessageById: getChirpThreadHistoryMessageById
      })
    })) : null;
    $[4] = Component;
    $[5] = channelName;
    $[6] = fileAttachmentsForMessage;
    $[7] = fileAttachmentsMap;
    $[8] = friendlyNames;
    $[9] = getChirpThreadHistoryMessageById;
    $[10] = hiddenBy;
    $[11] = idAttr;
    $[12] = isLastMessage;
    $[13] = message;
    $[14] = positionDescriptors;
    $[15] = presentSenderLocators;
    $[16] = recipientsMap;
    $[17] = senders;
    $[18] = slots;
    $[19] = threadId;
    $[20] = visitorLastReadTimestamp;
    $[21] = visitorRecipients;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  return t3;
}, shouldRerender);
MessageHistoryItem.displayName = 'MessageHistoryItem';
export default MessageHistoryItem;